import type { FitmentImportHistoryItem } from '../../app/api/agent';

export const isPreparingTagImport = (item?: FitmentImportHistoryItem) => !!item
    && item.importFormat === 'product_tags'
    && ['queued', 'pending', 'processing', 'in_progress', 'in progress', 'waiting for shopify sync', 'shopify sync needs attention']
        .includes(item.state.toLowerCase());

export const tagPreparationMessage = (item: FitmentImportHistoryItem) => {
    if (item.processingStage === 'blocked_shopify_sync')
        return 'We couldn’t get your latest products from Shopify. Check the connection to continue.';
    if (item.processingStage === 'waiting_shopify_sync')
        return 'Getting your latest products from Shopify…';
    return 'Checking your product tags for vehicle matches…';
};

export const tagIssueExplanation = (reason: string) => {
    if (/Multiple make names normalize/i.test(reason)) return 'More than one make name could match this tag.';
    if (/Ambiguous make boundary/i.test(reason)) return 'We couldn’t identify the make and model from your vehicle catalog.';
    if (/Multiple merchant model|Multiple vehicles in your catalog/i.test(reason)) return 'More than one vehicle in your catalog matches this tag.';
    if (/Ambiguous model\/submodel/i.test(reason)) return 'More than one model or submodel could match this tag.';
    if (/Unknown model\/submodel/i.test(reason)) return 'We couldn’t find this model and submodel for the make and year.';
    return reason;
};
